export const APIKey = "516707b64c9c114a3a8e8cde38d88f24";
export const mapBoxKey = "pk.eyJ1IjoibWFobW91ZC1mYXJhcmd5IiwiYSI6ImNrcXh1b25vaDB0eHYyb25ycGYxM3dvMGMifQ.ijhtYXJTdDs8u872ND_hNA";
export const FBConfig = {
    apiKey: "AIzaSyDJJl5WVoLGTJyc6z_a79Dj5yqbce3YmM0",
    authDomain: "weatherapp-63ab1.firebaseapp.com",
    projectId: "weatherapp-63ab1",
    storageBucket: "weatherapp-63ab1.appspot.com",
    messagingSenderId: "48589003129",
    appId: "1:48589003129:web:ef09f4b4b929938101b7a8",
    measurementId: "G-R1Q1C7V0PJ"
  };